import { useSocialFeedSettings } from '../../utils';

const MIN_GAP = 20;

export function useLayoutGap() {
  const {
    layout,
    carouselItemSpacing,
    gridItemSpacing,
    listItemSpacing,
    masonryItemSpacing
  } = useSocialFeedSettings();

  const spacing =
    {
      slider: MIN_GAP,
      carousel: carouselItemSpacing,
      grid: gridItemSpacing,
      list: listItemSpacing,
      masonry: masonryItemSpacing
    }[layout] ?? MIN_GAP;

  return {
    gap: Math.max(spacing, 0),
    minGap: MIN_GAP
  };
}
